import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

@injectable()
export class CrbConnectOrgRepo {
  constructor() {
    makeAutoObservable(this);
  }
}
